import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '../../contexts'
import { DarkModeToggle } from '../ui'
import { useHeaderSettings } from '../../hooks/useHeaderSettings'
import './Header.css'

export const Header: React.FC = () => {
  const { user, logout } = useAuth()
  const { headerSettings, loading } = useHeaderSettings()

  // Load Google Font dynamically
  useEffect(() => {
    if (headerSettings.headerFont) {
      // Remove any existing Google Font links for header fonts
      const existingLinks = document.querySelectorAll('link[data-header-font]')
      existingLinks.forEach(link => link.remove())

      // Create new link element for the font
      const link = document.createElement('link')
      const fontName = headerSettings.headerFont.replace(/\s+/g, '+')
      link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@300;400;500;600;700&display=swap`
      link.rel = 'stylesheet'
      link.setAttribute('data-header-font', 'true')
      document.head.appendChild(link)
    }
  }, [headerSettings.headerFont])

  // Create dynamic styles for header
  const headerStyle = {
    fontFamily: headerSettings.headerFont,
    color: headerSettings.headerColor
  }


  return (
    <header className="header">
      <div className="header__container">
        <div className="header__brand">
          {headerSettings.headerImageUrl && (
            <img 
              src={headerSettings.headerImageUrl} 
              alt={headerSettings.appTitle}
              className="header__logo"
            />
          )}
          <div className="header__title-container">
            <h1 className="header__title" style={headerStyle}>{headerSettings.appTitle}</h1>
            <span className="header__version" style={{ color: headerSettings.headerColor }}>
              v: {headerSettings.appVersion}
            </span>
          </div>
        </div>
        
        <div className="header__user">
          <div className="user-info">
            <span className="user-name">
              Welcome, {user?.first_name} {user?.last_name}
            </span>
            <span className="user-email">{user?.email}</span>
          </div>
          <div className="header__actions">
            <DarkModeToggle />
            <button 
              onClick={logout} 
              className="logout-button"
              aria-label="Logout"
              title="Logout"
            >
              <FontAwesomeIcon icon={faSignOut} />
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}
